import type { DiscoveredRouteModule } from '@/router/generator/types';

const GatewayTimeoutView = () => import('@/views/error-pages/GatewayTimeoutView.vue');
export const NAME_GATEWAY_TIMEOUT = 'GatewayTimeout';
export const PATH_GATEWAY_TIMEOUT = '/gateway-timeout';

export const route: DiscoveredRouteModule = {
  id: 'root.error.gateway_timeout',
  scope: 'root',
  name: NAME_GATEWAY_TIMEOUT,
  path: PATH_GATEWAY_TIMEOUT,
  component: GatewayTimeoutView,
  meta: { isErrorPage: true, requiresAuth: false, skipProjectCheck: true, skipPermissionCheck: true },
};


